import { render, staticRenderFns } from "./CartOrderRecord.vue?vue&type=template&id=a1175e6a&scoped=true&"
import script from "./CartOrderRecord.vue?vue&type=script&lang=js&"
export * from "./CartOrderRecord.vue?vue&type=script&lang=js&"
import style0 from "./CartOrderRecord.vue?vue&type=style&index=0&id=a1175e6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1175e6a",
  null
  
)

export default component.exports